/**
 * @description Normalizes Facebook event names to their canonical PascalCase form.
 * Handles variations like "pageview", "PageView", "page view" -> "PageView"
 * @param value - The event value to normalize (may contain spaces or varying case)
 * @param fallback - The fallback value to return if value is undefined or empty
 * @returns The normalized event name in canonical form
 */
export const normalizeFacebookEvent = (value: string | undefined, fallback: string): string => {
  if (!value) {
    return fallback;
  }
  const compact = value.replace(/\s+/g, "");
  const lower = compact.toLowerCase();
  if (lower === "pageview") {
    return "PageView";
  }
  if (lower === "submitapplication") {
    return "SubmitApplication";
  }
  return value;
};
